import React, { useState } from 'react';
import { ForgotPasswordPageProps, useTranslate } from '@refinedev/core';
import { ThemedTitle } from '../../../themedLayout/title';
import { layoutStyles, containerStyles, titleStyles, headStyles, bodyStyles, PageTitleStyles } from './styles';
import { Row, Col, Layout, Card, Typography, Button, LayoutProps, CardProps, FormProps, theme } from 'antd';
import { useResendVerifyEmail, useSharedEmail } from './auth/hooks';

type ResetPasswordProps = ForgotPasswordPageProps<LayoutProps, CardProps, FormProps>;

const { Title } = Typography;
const { useToken } = theme;

export const ConfirmEmailPage: React.FC<ResetPasswordProps> = ({
  wrapperProps,
  contentProps,
  renderContent,
  title,
}) => {
  const { token } = useToken();
  const translate = useTranslate();
  const PageTitle =
    title === false ? null : (
      <div
        style={{
          ...PageTitleStyles,
        }}
      >
        {title ?? <ThemedTitle collapsed={false} />}
      </div>
    );

  const [resendClicked, updateResendClicked] = useState(false);
  const { mutate: resendVerifyEmail, isLoading } = useResendVerifyEmail();
  const { email: registeredEmail } = useSharedEmail();
  const handleResendClick = () => {
    resendVerifyEmail(registeredEmail);
    updateResendClicked(true);
  };

  const ResendButton = (
    <Button type='link' loading={isLoading} onClick={handleResendClick}>
      Resend
    </Button>
  );

  const SentButton = (
    <Button type='link' disabled>
      Sent
    </Button>
  );

  const CardTitle = (
    <Title
      level={3}
      style={{
        color: token.colorPrimaryTextHover,
        ...titleStyles,
        textAlign: 'center',
        lineHeight: '32px',
      }}
    >
      {translate(
        'pages.confirmEmail.title',
        'We sent you a confirmation link to verify your email address. Please check your email.',
      )}
    </Title>
  );

  const CardContent = (
    <Card
      title={CardTitle}
      headStyle={headStyles}
      bodyStyle={bodyStyles}
      style={{
        ...containerStyles,
      }}
      {...(contentProps ?? {})}
    >
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          margin: '0',
          fontFamily: 'Roboto',
          fontWeight: '500',
          lineHeight: '24px',
          letterSpacing: '0em',
        }}
      >
        <Typography style={{ fontSize: '14px', lineHeight: '22px', paddingTop: '5px' }}>
          Didn&apos;t receive the link?
        </Typography>
        {resendClicked ? SentButton : ResendButton}
      </div>
    </Card>
  );

  return (
    <Layout style={layoutStyles} {...(wrapperProps ?? {})}>
      <Row
        justify='center'
        align='middle'
        style={{
          height: '100vh',
        }}
      >
        <Col xs={22}>
          {renderContent ? (
            renderContent(CardContent, PageTitle)
          ) : (
            <>
              {PageTitle}
              {CardContent}
            </>
          )}
        </Col>
      </Row>
    </Layout>
  );
};
